import React, { useState } from "react";

import { CloseGreyIcon, DeleteRedIcon, PlusBlackIcon, MinusBlackIcon } from "../../../../assets/icons";
import { CartProduct } from "../../../../models/helpers/product";
import FinishOrderView from "./FinishOrderView";
import { useNotification } from "../../../toster-notification/NotificationContext";
import { AnimatePresence, motion } from "framer-motion";
import { useCart } from "../../../../hooks/useCart";

interface BasketViewProps {
    onClose: () => void;
    cart: ReturnType<typeof useCart>;
    planSubscriptionFeatures: string[];
    primaryColor?: string;
}

const BasketView: React.FC<BasketViewProps> = ({ onClose, cart, planSubscriptionFeatures, primaryColor }) => {

    const [isFinishOrderViewOpen, setIsFinishOrderViewOpen] = useState(false);

    const { notify } = useNotification();
    const tableId = new URLSearchParams(window.location.search).get("tableId");

    const calculateTotal = (): number => {
        return cart.cartProducts.reduce((total, product) => {
            return total + (product.selectedVariant.price * product.quantity);
        }, 0);
    };

    if (tableId === null || tableId === undefined) {
        notify("error", "Greška pri učitavanju stola");
        onClose();
        return null;
    }

    return (
        <>

            <AnimatePresence>
                {isFinishOrderViewOpen && cart.cartProducts.length > 0 && (
                    <FinishOrderView
                        onClose={() => {
                            setIsFinishOrderViewOpen(false)
                            onClose();
                        }}
                        totalAmount={calculateTotal()}
                        tableId={tableId}
                        selectedItems={cart.cartProducts.map(prod => ({
                            productVariantId: prod.selectedVariant.id,
                            quantity: prod.quantity,
                            description: prod.note || ""
                        }))}
                        clearCart={() => cart.clearCart()}
                    />
                )}
            </AnimatePresence>

            <section className="client-basket-section" onClick={onClose}>
                <div className="w-layout-blockcontainer container w-container">
                    <motion.section
                        initial={{ opacity: 0, scale: 0.96, y: 12 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.96, y: 12 }}
                        transition={{ duration: 0.2 }}
                        style={{ height: "100%", display: "flex" }}
                    >
                        <div className="client-basket-wrapper">
                            <div className="client-basket-block-div" onClick={(e) => e.stopPropagation()}>
                                <div className="client-basket-header">
                                    <div>
                                        <div className="text-block-24">
                                            Vaša porudžbina<br />
                                        </div>
                                    </div>
                                    <div className="client-basket-close-button-div" onClick={onClose}>
                                        <img src={CloseGreyIcon} loading="lazy" alt="" className="icon-size-20 close" />
                                    </div>
                                </div>
                                <div className="client-basket-selected-items-list-div">

                                    {cart.cartProducts.map((product) => (

                                        <div className="client-basket-selected-item-div" key={product.selectedVariant.id}>

                                            {product.imageUrl && (
                                                <div className="client-basket-selected-item-image-div">
                                                    <img src={product.imageUrl + "@sm.webp"} loading="lazy" alt="" className="image-16" />
                                                </div>
                                            )}

                                            <div className="client-basket-selected-item-info-and-notification-div">
                                                <div className="client-basket-selected-item-info-block">
                                                    <div className="client-basket-selected-item-info">
                                                        <div className="client-basket-selected-item-name">{product.name} / <span className="text-span-10">{product.selectedVariant.label}</span></div>
                                                        <div className="client-basket-selected-item-quatity-block">

                                                            <div className="client-basket-selected-item-quantity-icon-div white-bg"
                                                                onClick={() => {
                                                                    if (product.quantity > 1) {
                                                                        cart.changeProductVariantQuantity(product.selectedVariant.id, product.quantity - 1);
                                                                    }
                                                                }}
                                                            >
                                                                <img src={MinusBlackIcon} loading="lazy" alt="" className="icon-size-12" />
                                                            </div>

                                                            <div className="client-basket-selected-item-quantity-div">
                                                                <div>{product.quantity}</div>
                                                            </div>

                                                            <div className="client-basket-selected-item-quantity-icon-div"
                                                                style={{ background: `linear-gradient(0deg, ${primaryColor}, ${primaryColor}aa)`, color: "white" }}
                                                                onClick={() => {
                                                                    cart.changeProductVariantQuantity(product.selectedVariant.id, product.quantity + 1);
                                                                }}
                                                            >
                                                                <img src={PlusBlackIcon} loading="lazy" alt="" className="icon-size-12" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="client-basket-selected-item-delete-and-price-div">
                                                        <img src={DeleteRedIcon} loading="lazy" alt="" className="icon-size-20 pointer"
                                                            onClick={() => { cart.removeProductVariant(product.selectedVariant.id) }}
                                                        />
                                                        <div className="client-basket-selected-item-price-div">
                                                            <div>{product.selectedVariant.price * product.quantity} RSD</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-block-5 w-form">
                                                    <form>
                                                        <textarea placeholder="Napomena (opciono)..." className="form-textarea client-order-item w-input"
                                                            defaultValue={product.note}
                                                            onChange={(e) => product.note = e.target.value}
                                                        ></textarea>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {planSubscriptionFeatures.some(f => f.startsWith("plus-order")) ? (
                                    <div className="client-basket-total-price-block">
                                        <div className="div-block-21">
                                            <div>Ukupno:</div>
                                            <div className="text-block-23">{calculateTotal()} RSD</div>
                                        </div>
                                        <div
                                            className="button-primary gradient client-basket"
                                            onClick={() => {
                                                if (cart.cartProducts.length === 0) {
                                                    notify("error", "Korpa je prazna");
                                                    return;
                                                }
                                                setIsFinishOrderViewOpen(true);
                                            }}
                                        >
                                            <div>Naruči</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="input-div">
                                        <div className="description-text" style={{ "marginLeft": "auto", "marginRight": "auto" }}>
                                            Lokal trenutno nema opciju za naručivanje
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    </motion.section>
                </div>
            </section >

        </>
    );
}

export default BasketView;